import React from 'react';
import { MainStore } from '../../../stores/MainStore';

export enum PIPIconType {
    Legal = 0,
    Marketing = 1,
}

export interface PIPIcon {
    type: PIPIconType;
    imageUrl: string;
    imageAltTag: string;
}

export type PictureInPictureProps = {
    store: MainStore;
    children: React.ReactNode;
}